import Vue from 'vue'
import axios from 'axios'

// Quem está conectado no camera-gateway agora, pelo ID do terminal sem zeros à esquerda.
// Observable para a célula da tabela se atualizar quando a resposta chegar.
export const cameraStatus = Vue.observable({ available: null, online: {} })

const REFRESH_MS = 30000
let loadedAt = 0

export function loadCameraStatus(api) {
  if (Date.now() - loadedAt < REFRESH_MS) return
  loadedAt = Date.now()
  axios
    .get(`${api}cameras/status`)
    .then(response => {
      const body = response.data || {}
      cameraStatus.available = !!body.available
      cameraStatus.online = body.data || {}
    })
    .catch(() => {
      cameraStatus.available = false
    })
}

export function isCameraOnline(terminal) {
  const key = String(terminal || '').replace(/^0+/, '')
  return !!key && !!cameraStatus.online[key]
}
